<template>
  <div id="SuiteRentals">
    <HeroSlider :sliderImages="sliderImages" />
    <section id="suites">
      <Suites />
    </section>
    <section id="schedule-section">
      <Schedule />
    </section>
  </div>
</template>

<script>
import Suites from "@/components/SuiteRentals/Suites/Suites";
import Schedule from "@/components/SuiteRentals/Schedule";
import HeroSlider from "@/components/HeroSlider";
import { suiteRentalImages } from "@/data/suiteRentalsSliderData.js";

export default {
  name: "SuiteRentals",
  components: {
    Suites,
    Schedule,
    HeroSlider,
  },
  data() {
    return {
      sliderImages: suiteRentalImages,
    };
  },
};
</script>

<style lang="scss" scoped>
#SuiteRentals {
  #schedule-section {
    background: linear-gradient(134.22deg, #fbfbfb 0%, #eaeaea 100%);
  }
}
</style>
